import React, { FunctionComponent, useEffect, useRef, useState } from 'react'
import { Button, Form, Input, message, Modal, Tooltip } from 'antd'
import { hot } from 'react-hot-loader/root'
import { observer } from 'mobx-react'
import { AppStore } from 'src/pc/store/AppStore'
import { DWbindRealNameAuthHttp, GetAuthStatusHttpHS } from 'src/commons/store/UserStore'
import { closeAuthModal, getContact } from 'src/pc/store/UIController'
import { CardIdPattern, getAge, NamePattern } from 'src/commons/utils'
import { getPhpToken } from 'src/pc/utils/auth'
import { useWaitModData } from '@hhpack/use-cms'
import { getUserInfo } from 'src/pc/store/UserStore'
import { DWGetOrderInfo, DWisFastRefundHttp } from 'src/commons/store/BasisStore'
import { getCommonPromise, CommonPromiseKeyMapping } from 'src/commons/utils'
import styled from '@emotion/styled'
import StartProblem from 'src/pc/components/StartProblem'
import useContact from 'src/pc/components/hooks/useContact'

import NameIcon from 'src/pc/assets/icons/name-icon.svg'
import CardIcon from 'src/pc/assets/icons/card-icon.svg'
import questionIcon from 'src/pc/assets/icons/wenhao.png'

type RealNameAuthProps = {}

const RealNameAuth: FunctionComponent<RealNameAuthProps> = () => {
  const [form] = Form.useForm()
  const { validateFields, resetFields } = form
  const [htmlStr, setHtmlStr] = useState<string>('')
  const [startProblemVisible, setStartProblemVisible] = useState(false)
  const [orderInfo, setOrderInfo] = useState<OrderInfo>()
  const [loading, setLoading] = useState(false)
  // const [IDCard, setIDCard] = useState<string>('')
  const authformRef = useRef<any>(null)
  //非空、校验不通过的提交次数
  const submitErrTimesRef = useRef(0)

  const handleSimpleclientRealnameAuth = async () => {
    const simpleClientRealnameAuth = await useWaitModData<{ des: string }>('simpleclient_realname_auth')
    const des = simpleClientRealnameAuth?.[0]?.des || ''
    setHtmlStr(des)
  }

  const sendAuth = async () => {
    const values = await validateFields(['Name', 'CardId'])
    // setIDCard(values.CardId)
    const userAge = getAge(values.CardId)
    // if (userAge < 18) {
    //   try {
    //     setLoading(true)
    //     authformRef?.current?.resetFields()
    //     message.warning('平台不对未成年人提供游戏服务')
    //     if (!(await check())) {
    //       submitErrTimesRef.current++
    //     }
    //   } catch (error) {
    //   } finally {
    //     setLoading(false)
    //   }
    //   return
    // }
    try {
      setLoading(true)
      await DWbindRealNameAuthHttp.Execute({ realName: values.Name, idCardNo: values.CardId })
      resetFields()
      GetAuthStatusHttpHS.Execute()
      getCommonPromise(CommonPromiseKeyMapping.REAL_NAME_AUTH).resolve?.(userAge > 40)
      closeAuthModal()
      getUserInfo(getPhpToken()!)
      message.success('认证通过')
    } catch (error) {
      if (error.message === '认证失败') {
        handleOpenArtificialAuth()
        message.warning('认证失败，为您接入人工实名认证')
      } else {
        message.warning(error.message)
        if (!(await check())) {
          submitErrTimesRef.current++
        }
      }
    } finally {
      setLoading(false)
    }
  }
  const handleOpenArtificialAuth = () => {
    AppStore.realNameAuthModal = false
    AppStore.artificialAuthModal = true
  }

  const getOrderInfo = () => {
    DWGetOrderInfo.Execute({
      userGameId: AppStore.startGameOrderInfo,
    }).then(res => {
      setOrderInfo(res)
    })
  }

  const check = async () => {
    if (orderInfo?.payType !== 'wechat') {
      return true
    }
    if (submitErrTimesRef.current >= 3) {
      let fastRefund = false
      //是否能极速退款
      try {
        const fastRefundRes = await DWisFastRefundHttp.Execute({ userGameId: AppStore.startGameOrderInfo })
        fastRefund = fastRefundRes.speedRefund
      } catch (e) {
        console.log('fastRefundRes err', e)
      }
      if (fastRefund) {
        setStartProblemVisible(true)
      } else {
        getContact()
      }
      AppStore.realNameAuthModal = false
      return true
    }
    return false
  }

  const onFailed = async ({ values }: any) => {
    const { Name, CardId } = values
    try {
      setLoading(true)
      if (!(await check()) && Name && CardId) {
        submitErrTimesRef.current++
      }
    } catch (error) {
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    if (AppStore.realNameAuthModal) {
      localStorage.setItem('realNameAuthModal', '1')
      AppStore.startGameOrderInfo && getOrderInfo()
    } else {
      submitErrTimesRef.current = 0
      AppStore.startGameOrderInfo = 0
    }
  }, [AppStore.realNameAuthModal])

  useEffect(() => {
    handleSimpleclientRealnameAuth()
  }, [])

  return (
    <>
      <StyledRealNameAuth
        className="custom RealNameAuth"
        width={510}
        visible={AppStore.realNameAuthModal} //AppStore.realNameAuthModal
        onCancel={closeAuthModal}
        title="个人实名信息认证"
        footer={false}
        zIndex={1008}
      >
        <StyledHtml dangerouslySetInnerHTML={{ __html: htmlStr }}></StyledHtml>
        <StyledAuthTip>
          注册信息只能提交一次，不可修改，请慎重填写。该信息仅用于实名认证不会泄露于任何第三方
        </StyledAuthTip>
        <Form
          ref={authformRef}
          onFinish={sendAuth}
          onFinishFailed={onFailed}
          className="custom"
          form={form}
          autoComplete="off"
        >
          <Form.Item
            name="Name"
            rules={[
              { required: true, message: '请输入您的真实姓名' },
              { pattern: NamePattern, message: '姓名格式不合规，可点击下方“人工辅助认证”' },
            ]}
            validateTrigger="onBlur"
          >
            <Input placeholder="请输入您的真实姓名" prefix={<NameIcon />} readOnly={false} />
          </Form.Item>
          <Form.Item
            name="CardId"
            rules={[
              { required: true, message: '请输入您的身份证号' },
              { pattern: CardIdPattern, message: '请输入正确的身份证号码' },
            ]}
            validateTrigger="onBlur"
          >
            <Input placeholder="请输入您的身份证号" prefix={<CardIcon />} readOnly={false} />
          </Form.Item>
          <Form.Item>
            <Button block htmlType="submit" loading={loading}>
              开始认证
            </Button>
          </Form.Item>
        </Form>
        <StyledRealName>
          <div className="des filter" onClick={handleOpenArtificialAuth}>
            人工辅助认证入口{'>'}
          </div>
          <Tooltip title="为了给玩家带来更好的体验，部分用户可提供证件图片，进行人工实名认证">
            <img className="icon filter" src={questionIcon} />
          </Tooltip>
        </StyledRealName>
      </StyledRealNameAuth>
      <StartProblem visible={startProblemVisible} onCancel={() => setStartProblemVisible(false)} order={orderInfo} />
    </>
  )
}

export const awaitRealNameAuthModal = async () => {
  AppStore.realNameAuthModal = true
  return new Promise(resolve => {
    getCommonPromise(CommonPromiseKeyMapping.REAL_NAME_AUTH).resolve = resolve
  })
}

const StyledRealNameAuth = styled(Modal)`
  .custom {
    width: 310px;
    margin: 0 auto;
    margin-top: 30px;
  }
  .ant-form-item-has-error .ant-input-affix-wrapper,
  .ant-form-item-has-error .ant-input-affix-wrapper:hover,
  .ant-form-item-has-error .ant-input:hover {
    background-color: #22262a !important;
  }
  .ant-modal-body {
    padding: 20px;
  }
  .ant-modal-header {
    padding: 0 !important;
    display: flex;
    height: 57px;
    justify-content: center;
    align-items: center;
    border-bottom: 1px solid rgba(42, 48, 54, 1) !important;
  }
  .ant-modal-content {
    position: relative;
    overflow: hidden;
  }

  .OtherLogin {
    text-align: center;
    margin-bottom: 0;

    button {
      width: 40px;
      height: 40px;
      border-radius: 50%;
      padding: 0;
      text-align: center;
      border-color: #4a4a4a;
      font-size: 24px;
      line-height: 38px;
      background-color: transparent;
      color: #00bb2b;
    }
  }

  .SignInWithWeiXin {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    transition: all 0.3s;
    height: 395px;
    overflow: hidden;
    background: #22262a;
    box-shadow: 0 0 14px 0 rgba(10, 34, 57, 0.4);
    z-index: 2001;
    top: 395px;

    &.active {
      top: 0;
    }

    header {
      text-align: right;

      button {
        color: #4a4a4a;
        background-color: transparent;
        border-color: transparent;

        i {
          color: #d0d0d0;
        }

        &:hover,
        &:active,
        &:focus {
          background-color: transparent;
        }
      }
    }
  }

  .ShowBindWeiXin {
    padding: 24px;
  }

  .ant-divider {
    font-size: 14px;
    color: #999999;
    font-weight: normal;
    display: flex;
    align-items: center;
    &:before,
    &:after {
      flex: 1;
      height: 1px;
      border: none;
      background-color: #3e3e3e;
    }
  }
  .ant-checkbox-wrapper + a {
    color: #999;
  }
  .ant-modal-footer {
    padding: 0;
    text-align: center;
    background-color: #1d2125;
    line-height: 34px;
    border-top: none;
    p {
      margin-bottom: 0;
      font-size: 12px;
      color: #999999;
    }
    a {
      color: #999999;
    }
  }
`
const StyledRealName = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  cursor: pointer;
  .icon {
    width: 16px;
    height: 16px;
    margin-left: 6px;
  }
  .des {
    font-size: 12px;
    color: #909294;
  }
`
const StyledAuthTip = styled.div`
  font-size: 12px;
  color: rgba(255, 255, 255, 0.5);
  border-top: 1px solid #2a3036;
  margin-top: 26px;
  padding-top: 10px;
`
const StyledHtml = styled.div`
  p {
    margin-bottom: 0px;
  }
`

export default hot(observer(RealNameAuth))
